// Class: motion.easing._Sine.SineEaseInOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var SineEaseInOut = function() {
}

// Meta

SineEaseInOut.__name__ = ["motion","easing","_Sine","SineEaseInOut"];
SineEaseInOut.__isInterface__ = false;
SineEaseInOut.__interfaces__ = [(motion_easing_IEasing().default)];
SineEaseInOut.prototype = {
	calculate: function(k) {
		return -(Math.cos(Math.PI * k) - 1) / 2;
	},
	ease: function(t,b,c,d) {
		return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	}
};
SineEaseInOut.prototype.__class__ = SineEaseInOut.prototype.constructor = $hxClasses["motion.easing._Sine.SineEaseInOut"] = SineEaseInOut;

// Init



// Statics




// Export

exports.default = SineEaseInOut;